import React from 'react';
import { Flex, Text } from '../../../Components';

export default function SignInformation({ generalInfo = {}, code, isExpired, logo }) {
  const { environment, agencyName, userEmail, userPhone } = generalInfo;

  // ---- ViaggiGiovani custom message ----
  const viaggiGiovaniMessage = (
     <Flex direction="column" fw  style={{ alignItems: 'flex-start' }}>
      {/* Title */}
      <Text
        bold
        size={32}
        value="RICHIESTA FIRMA DIGITALE"
        style={{ marginBottom: 25, alignSelf: 'center' }}
      />
      <div style={{color: '#32324e'}}>
        <p>
          Ecco i <strong>passaggi</strong> da seguire per <strong>scaricare, salvare e leggere il contratto di viaggio </strong> 
          prima di procedere con la <strong>firma digitale</strong>:
        </p>

        <ol>
          <li>Clicca su <strong>Richiedi OTP</strong></li>
          <li><strong>Inserisci il codice OTP</strong> che riceverai al numero {generalInfo?.userPhone} per accedere al documento</li>
          <li><strong>Controlla</strong> il contratto (puoi anche scaricarlo o stamparlo)</li>
          <li><strong>Accetta</strong> i consensi obbligatori</li>
          <li><strong>Firma</strong> il documento scegliendo una delle modalità proposte</li>
          <li>Riceverai una <strong>copia del contratto firmato</strong> all’indirizzo e-mail: {generalInfo?.userEmail}</li>
        </ol>
      </div>

    </Flex>
  );

  // ---- Generic header ----
  const defaultHeader = (
    <Text
      size={25}
      value="Benvenuto nella pagina per effettuare una richiesta di firma da remoto."
    />
  );

  // ---- Generic information section ----
  const infoSection = (
    <Flex column style={{ marginTop: 25 }}>
      {agencyName && (
        <Text size={25} value={`La seguente richiesta di firma proviene da: ${agencyName}.`} />
      )}
      {userEmail && (
        <Text
          size={25}
          value={`Email dell'utente a cui è indirizzata la firma: ${userEmail}.`}
          style={{ marginTop: 10 }}
        />
      )}
      {userPhone && (
        <Text
          size={25}
          value={`Telefono dell'utente a cui è indirizzata la firma: ${userPhone}.`}
          style={{ marginTop: 10 }}
        />
      )}
    </Flex>
  );

  // ---- Status or error messages ----
  const expiredMessage = (
    <Text
      size={25}
      value="La tua richiesta di firma è scaduta, contatta l'agenzia per maggiori informazioni."
    />
  );
  const invalidCodeMessage = (
    <>
      <Text
        size={25}
        value={`Il codice ${code} non corrisponde a nessuna richiesta di firma ancora da completare.`}
      />
      <Text
        size={25}
        value="Contatta l'agenzia che te lo ha fornito per maggiori informazioni."
      />
    </>
  );

  // ---- Main content selector ----
  const renderContent = () => {
    if (environment === 'viaggigiovani') return viaggiGiovaniMessage;
    if (isExpired) return expiredMessage;
    if (agencyName || userEmail || userPhone) return infoSection;
    return invalidCodeMessage;
  };

  return (
    <Flex direction="column" style={{ margin: 10 }}>
      {environment !== 'viaggigiovani' && defaultHeader}
      {renderContent()}
    </Flex>
  );
}
